import styled, { css } from 'styled-components';

export const TableCell = styled.div`
  display: inline-block;
  empty-cells: show;
  ${({ heading, left }) => {
    if (heading) {
      return css`
        font-weight: 600;
      `;
    } else if (left) {
      return css`
        font-weight: 500;
      `;
    }
  }}
  ${({ left }) => {
    if (!left) {
      return css`
        text-align: right;
        word-break: break-word;
      `;
    }
  }};
`;
